module.exports = __webpack_public_path__ + "img/icon-send.069f9c82.svg";